import { Select } from '../../../components/Select';
import { ProductVariants } from '../../../types/generated';

export interface VariantsProps {
  onChange: (facetGroupId: number, facetId: number | null) => void;
  variants?: ProductVariants | null;
}

export function Variants({ variants, onChange }: VariantsProps) {
  if (!variants || !variants.facets) {
    return null;
  }

  const facets = variants.facets;

  function changeSelection(facetGroupId: number, facetId: number | null) {
    onChange(facetGroupId, facetId);
  }

  return (
    <div className="product-variants">
      {facets.map((facetGroup) => {
        if (!facetGroup || !facetGroup.facetValues) {
          return null;
        }

        const selectedFacet = facetGroup.facetValues.find((f) => f.isSelected);

        return (
          <Select
            size="sm"
            id={`facetGroup-${facetGroup.id}`}
            key={facetGroup.id}
            label={facetGroup.name}
            onChange={(e) => {
              const id = parseInt(e.target.value, 10);

              changeSelection(facetGroup.id, id || null);
            }}
            labelClassName="col-4 col-sm-3 col-lg-4"
            inputClassName="col-8 col-sm-7 col-lg-8 align-self-center"
            value={(selectedFacet && selectedFacet.facetValueId) || -1}
          >
            <option value={-1} />
            {facetGroup.facetValues.map((facetValue) => (
              <option
                key={facetValue.facetValueId}
                value={facetValue.facetValueId}
              >
                {facetValue.facetValue}
              </option>
            ))}
          </Select>
        );
      })}

      {/* Mobile/tablet */}
      {variants?.hasNoProductForCombination && (
        <div className="d-lg-none form-feedback form-feedback--errors">
          <p className="form-feedback__text">
            No product is currently available for this combination
          </p>
        </div>
      )}
    </div>
  );
}

// const dummyVariants: DummyVariants = {
//   variantHeaderCatalogRef: 'g1761266',
//   variantCatalogRef: null,
//   hasVariantProduct: false,
//   facets: [
//     {
//       name: 'Colour',
//       id: 121,
//       facetValues: [
//         {
//           facetValueId: 57242,
//           facetValue: 'Black',
//           isSelected: false,
//         },
//         {
//           facetValueId: 57243,
//           facetValue: 'Blue',
//           isSelected: false,
//         },
//         {
//           facetValueId: 57247,
//           facetValue: 'Green',
//           isSelected: false,
//         },
//         {
//           facetValueId: 57254,
//           facetValue: 'Orange',
//           isSelected: false,
//         },
//         {
//           facetValueId: 57259,
//           facetValue: 'Red',
//           isSelected: false,
//         },
//       ],
//     },
//     {
//       name: 'Manufactures Size by Inches (Chest)',
//       id: 2893,
//       facetValues: [
//         {
//           facetValueId: 60037,
//           facetValue: '50-52in',
//           isSelected: false,
//         },
//         {
//           facetValueId: 60038,
//           facetValue: '50-54in',
//           isSelected: false,
//         },
//       ],
//     },
//   ],
// };

// export interface DummyVariants {
//   variantHeaderCatalogRef: string;
//   variantCatalogRef: null;
//   hasVariantProduct: boolean;
//   facets: Facet[];
// }

// export interface Facet {
//   name: string;
//   id: number;
//   facetValues: FacetValue[];
// }

// export interface FacetValue {
//   facetValueId: number;
//   facetValue: string;
//   isSelected: boolean;
// }
